export default __webpack_public_path__ + "static/media/Forgot_Your_password.ca976864.svg";